import axios from 'axios';

export const VERIFY_STUDENT_BEGIN = 'VERIFY_STUDENT_BEGIN';
export const VERIFY_STUDENT_SUCCESS = 'VERIFY_STUDENT_SUCCESS';
export const VERIFY_STUDENT_FAILURE = 'VERIFY_STUDENT_FAILURE';

export const verifyStudentBegin = () => ({
    type: VERIFY_STUDENT_BEGIN
});

export const verifyStudentSuccess = (value) => ({
    type: VERIFY_STUDENT_SUCCESS,
    payload: value
});

export const verifyStudentFailure = (error) => ({
    type: VERIFY_STUDENT_FAILURE,
    payload: error
});

export const verifyStudentDetails = (webappurlForms, accessToken, studentArn, studentFamilyName) => {
    return dispatch => {
        const options = {
            headers: {
                'Authorization': "Bearer " + accessToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
       
        dispatch(verifyStudentBegin());
        //TODO: FIX url to point to dev environment once API is deployed
        return axios.post(webappurlForms + "/api/myCASA/Forms/verifyIndividual/v1", {"arn": studentArn, "surname": studentFamilyName}, options)
            .then(response => {
                //TODO: Change to wasSuccessful check once API has been updated
                if (response.data.verifiedIndividual) {
                    return dispatch(verifyStudentSuccess(response.data.individualDetails));
                }
                else {
                    return dispatch(verifyStudentFailure("System error FSU.1a: " + response.data.message));
                }
            })
            .catch(error => {
                return dispatch(verifyStudentFailure(error.response ? error.response.data.errors : error));
            });
    };
}
